import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify'

function WindowFocusHandler({ onDataReceived }) {
  const [focusCount, setFocusCount] = useState(0);

  const myFunction = () => {
    console.log("www");
  };

  useEffect(() => {
    const handleFocus = () => {
      setFocusCount((prevCount) => {
        const newCount = prevCount + 1;
        // console.log(onDataReceived, "www")
        if (newCount < 4) {
          // onDataReceived("newValuezzz")
          toast.warning(`Ventana desenfocada ${newCount} en la tercera se cerrará`)
          myFunction();
        }else{
          toast.info(`Ventana desenfocada ${newCount}`)
          onDataReceived("newValuezzz")
        }
        return newCount;
      });
    };

    // Attach event listener
    window.addEventListener('focus', handleFocus);

    // Clean up event listener
    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, []);

  return (
    <div>
      <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />
      {focusCount===0?'':<p className='text-center text-warning'>Ventana desenfocada {focusCount} {focusCount>1?'veces':'vez'}, en la tercera se bloqueará</p>}
    </div>
  );
}

export default WindowFocusHandler;
